import { FilterModal, SearchFilter } from '@synergy/components';
import { FormattedMessage } from 'react-intl';

import { ImportChangeStateFilter } from '../components/import-change-state-filter';
import { ImportDetailTabs } from '../models/import-detail-tabs';
import { MaxPriceChangeRatioFilter } from '../../../../common/components/filter/max-price-change-ratio-filter';
import { MinMaxPriceFilter } from '../../../../common/components/filter/min-max-price-filter';

interface ImportDetailFilterProps {
    selectedTab: ImportDetailTabs;
}

export const ImportDetailFilter = (props: ImportDetailFilterProps) => {
    return (
        <>
            <FilterModal title={<FormattedMessage id="app.imports.detail.filterTitle" />}>
                <MaxPriceChangeRatioFilter />
                <MinMaxPriceFilter />
                <ImportChangeStateFilter selectedTab={props.selectedTab} />
            </FilterModal>
            <SearchFilter />
        </>
    );
};
